// eslint-disable-next-line
import { UserLayout } from '@/layouts'

export const asyncRouterMap = [
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register')
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/RegisterResult')
      },
      {
        path: 'tenantSelect',
        name: 'tenantSelect',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Tenant')
      },
      {
        path: 'modifyPwd',
        name: 'modifyPwd',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/ModifyPwd')
      },
      {
        path: 'usergreement',
        name: 'usergreement',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/usergreement')
      },
      {
        path: 'agreement',
        name: 'agreement',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/agreement')
      },
      {
        path: 'recover',
        name: 'recover',
        component: undefined
      },
      {
        name: 'guide',
        path: '/guide',
        component: () => import('@/views/operating/guide/index')
      }
    ]
  },

  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  }
]
